import React, {useState, useEffect} from 'react';
import { Outlet, useNavigate, Link } from "react-router-dom";
import { Layout, Button, Modal} from 'antd';
import Cookies from 'js-cookie';
import { UserOutlined } from '@ant-design/icons';
import PwChange from '../components/PwChange';
import axios from './Common/axios';
import {postSaveLog} from './Common/api';

const { Header, Content, Footer, } = Layout;

const Home = () => {
  const navigate = useNavigate();
  // 쿠키에서 인증 토큰 값 가져오기
  const authToken = Cookies.get('access_token');
  // 인증 토큰 값이 존재하면 로그인된 상태로 처리
  const authenticated = authToken?true:false;

  useEffect(() => {
    if(authToken) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  }, []);

  // 변수 선언
  const [isPwChange, setIsPwChange] = useState(false);

  //비밀번호변경
  const pwChange = () => {
    setIsPwChange(true);
  }

  //로그아웃
  const logout = () => {

    // 접속 로그 기록(세션정보 삭제 전에 로그아웃 기록)
    axios.post(postSaveLog(), {
      com_cd : Cookies.get('auth_companyCode'),
      log_type : '/logout/',
      log_user : Cookies.get('auth_user'),
      log_url : '/logout/',
      log_param : '',
    }, {logType:'log'})
    .then((response) => {
        // 쿠키에서 인증 토큰 삭제하기
        Cookies.remove('access_token');
        Cookies.remove('refresh_token');
        Cookies.remove('auth_companyCode');
        Cookies.remove('auth_companyName');
        Cookies.remove('auth_user');
        Cookies.remove('auth_userName');
        Cookies.remove('auth_superuser');
        localStorage.removeItem('code_list');
        window.location.replace("/");
    })
    .catch((error) => {
        console.log("Home.js --- 59 error");
        console.dir(error);
        // API 호출 실패해도 클라이언트 정리는 진행
        Cookies.remove('access_token');
        Cookies.remove('refresh_token');
        Cookies.remove('auth_companyCode');
        Cookies.remove('auth_companyName');
        Cookies.remove('auth_user');
        Cookies.remove('auth_userName');
        Cookies.remove('auth_superuser');
        localStorage.removeItem('code_list');
        window.location.replace("/");
    });

  }

  return (
    <Layout>
        <Header>
        <div className="logo">
          
          {/* &nbsp;<span className='logo_key' style={{color:'#2879C6'}}>PROM</span>&nbsp;  */}
          i<span className='logo_key' style={{color:'#2879C6'}}>S</span>ecure 
          &nbsp;<span className='logo_key' >R</span>isk 
          &nbsp;<span className='logo_key'>M</span>anagement 
          &nbsp;<span className='logo_key'>S</span>ystem
        </div>
        {authenticated ? (
          <>
            <span className='login_text'>
              {Cookies.get('auth_companyName')} &nbsp; | &nbsp; {Cookies.get('auth_userName')}
              <UserOutlined style={{paddingLeft:'25px', paddingRight:'15px', fontSize:'30px'}} onClick={pwChange} />
            </span>
            <Button type="primary" className="login_button" onClick={logout}>Logout</Button>
            {isPwChange && (<PwChange onLogout={logout} onClose={() => {setIsPwChange(false);}}/>)}
          </>
        ) : (
          <></>
          // <Link to="/login">
          //   <Button type="primary" className="login_button">Login</Button>
          // </Link>
        )}
      </Header>
      <Layout>
          <Outlet />
      </Layout>
      <Footer style={{ paddingLeft: 0, marginLeft: 0 , position:'fixed', bottom:0}}>Risk Management System © 2025 iSecure Inc.</Footer>
    </Layout>
  );
};
  
  export default Home;